/*
  vm-plint-doorsnede.js
  Tekent een dwarsdoorsnede (SVG) van een MDF-plint uit uitvoering, dikte en hoogte in mm.
  Geen afbeeldingen nodig: elk profiel is een pad in millimeters dat op schaal wordt gezet.

  Gebruik:
    window.vmPlintDoorsnede(svgElement, { uitvoering: 'Koloniale Plint', dikte: 15, hoogte: 90, kleur: '#f1ece1' })
    -> tekent in het svg-element en geeft { profiel: 'koloniaal' } terug (of false bij ongeldige maten).

  Coördinaten per profiel: x = 0 is de wand (achterkant), x = t het zichtvlak; y = 0 boven, y = h de vloer.
*/
(function (w) {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';
  var RAL = {
    '9010': '#f1ece1', '9016': '#f4f4f0', '9001': '#e9e0d2', '9005': '#0f0f11', '7016': '#383e42', grond: '#ece9e0'
  };

  function r(n) { return Math.round(n * 100) / 100; }
  function el(naam, attrs) {
    var e = document.createElementNS(NS, naam);
    for (var k in attrs) if (Object.prototype.hasOwnProperty.call(attrs, k)) e.setAttribute(k, attrs[k]);
    return e;
  }

  // Kabelgoot: holle uitsparing aan de achterkant onderaan (zichtbaar op de fabrieksfoto's van alle MDF-profielen).
  function goot(t, h) {
    var c = Math.min(5, t * 0.4);
    return ' L' + r(c) + ',' + r(h) + ' A' + r(c) + ' ' + r(c) + ' 0 0 0 0,' + r(h - c) + ' Z';
  }
  function start(t, h) { var c = Math.min(5, t * 0.4); return 'M0,' + r(h - c) + ' L0,0'; }

  function overzetUitsparing(t, h, o) {
    var u = o && o.uitsparing ? o.uitsparing : null;
    var diepte = u && u.diepte > 0 && u.diepte < t ? u.diepte : Math.min(13, t - 4);
    var hoogte = u && u.hoogte > 0 && u.hoogte < h ? u.hoogte : (h > 100 ? 90 : 60);
    return { diepte: diepte, hoogte: hoogte };
  }

  // Extra vlakken per profiel (in mm): de uitsparing van een overzetplint als licht gestippeld vlak,
  // zodat zichtbaar is dat de achterkant open is en waar de maatlijnen bij horen.
  var EXTRA_VLAKKEN = {
    overzet: function (t, h, o) {
      var u = overzetUitsparing(t, h, o);
      return [{ x: 0, y: h - u.hoogte, b: u.diepte, hg: u.hoogte }];
    }
  };

  // Extra maatlijnen per profiel (in mm), naast dikte en hoogte.
  var EXTRA_MATEN = {
    overzet: function (t, h, o) {
      var u = overzetUitsparing(t, h, o);
      return [
        { richting: 'v', x: 0, y1: h - u.hoogte, y2: h, mm: u.hoogte, kant: 'links' },
        { richting: 'h', y: h, x1: 0, x2: u.diepte, mm: u.diepte, kant: 'onder' }
      ];
    }
  };

  var PROFIELEN = {
    // Strak, kleine ronding op de voorkant boven.
    modern: function (t, h) {
      var rc = Math.min(3, t / 3);
      return start(t, h) + ' L' + r(t - rc) + ',0 A' + r(rc) + ' ' + r(rc) + ' 0 0 1 ' + r(t) + ',' + r(rc) + ' L' + r(t) + ',' + r(h) + goot(t, h);
    },
    // Rechte folieplint: scherpe rechthoek, geen goot.
    recht: function (t, h) {
      return 'M0,' + r(h) + ' L0,0 L' + r(t) + ',0 L' + r(t) + ',' + r(h) + ' Z';
    },
    // Overzet-/renovatieplint: kap van volle dikte, daaronder alleen de voorplaat.
    // Uitsparing achter (diepte x hoogte) komt uit de variantnaam, bv. "18x120 mm (Met uitsparing 13x90mm)";
    // zonder opgave: 13 mm diep en 60 mm (tot 100 mm hoog) of 90 mm hoog.
    overzet: function (t, h, o) {
      var u = overzetUitsparing(t, h, o), ch = 3;
      // uitsparing loopt van de wand (x = 0) tot x = diepte; de voorplaat is t - diepte dik
      return 'M' + r(u.diepte) + ',' + r(h) + ' L' + r(u.diepte) + ',' + r(h - u.hoogte) + ' L0,' + r(h - u.hoogte) + ' L0,0 L' + r(t - ch) + ',0 L' + r(t) + ',' + ch + ' L' + r(t) + ',' + r(h) + ' Z';
    },
    // Geluidreducerend: modern profiel met sleuf onderin voor de contactstrip.
    geluid: function (t, h) {
      var rc = 3, rb = 2, c = Math.min(5, t * 0.4), m = Math.max(c + 2.5, t / 2);
      return start(t, h) + ' L0,' + rb + ' A' + rb + ' ' + rb + ' 0 0 1 ' + rb + ',0 L' + r(t - rc) + ',0 A' + rc + ' ' + rc + ' 0 0 1 ' + r(t) + ',' + rc +
        ' L' + r(t) + ',' + r(h) + ' L' + r(m + 1) + ',' + r(h) + ' L' + r(m + 1) + ',' + r(h - 8) + ' L' + r(m - 1) + ',' + r(h - 8) + ' L' + r(m - 1) + ',' + r(h) + goot(t, h);
    },
    // Tijdloos (Luxe): afschuining boven en een V-groef op een derde van de hoogte.
    tijdloos: function (t, h) {
      var ch = 3, g = Math.round(h * 0.3);
      return start(t, h) + ' L' + r(t - ch) + ',0 L' + r(t) + ',' + ch + ' L' + r(t) + ',' + r(g - 1.5) + ' L' + r(t - 2) + ',' + g + ' L' + r(t) + ',' + r(g + 1.5) + ' L' + r(t) + ',' + r(h) + goot(t, h);
    },
    // Koloniaal: grote ronding (bullnose) op de voorkant boven.
    koloniaal: function (t, h) {
      var R = Math.min(t * 0.7, 12);
      return start(t, h) + ' L' + r(t - R) + ',0 A' + r(R) + ' ' + r(R) + ' 0 0 1 ' + r(t) + ',' + r(R) + ' L' + r(t) + ',' + r(h) + goot(t, h);
    },
    // Kraal: kraal (bolling) boven, daaronder een holle hals die terugkomt op het zichtvlak.
    kraal: function (t, h) {
      var rb = Math.min(5, t * 0.4), cv = 10, d = Math.min(4, t * 0.3);
      return start(t, h) + ' L' + r(t - 1 - rb) + ',0 A' + r(rb) + ' ' + r(rb) + ' 0 0 1 ' + r(t - 1) + ',' + r(rb) + ' L' + r(t - 1) + ',' + r(rb + 1) +
        ' Q' + r(t - 1 - 2 * d) + ',' + r(rb + 1 + cv / 2) + ' ' + r(t) + ',' + r(rb + 1 + cv) + ' L' + r(t) + ',' + r(h) + goot(t, h);
    },
    // Romance: smalle kop met ronding, trapje terug, dan een hol dat uitloopt op het zichtvlak.
    romance: function (t, h) {
      var s = 3, rc = 3, ub = 8, cv = 12;
      return start(t, h) + ' L' + r(t - s - rc) + ',0 A' + rc + ' ' + rc + ' 0 0 1 ' + r(t - s) + ',' + rc + ' L' + r(t - s) + ',' + ub +
        ' C' + r(t - s - 3) + ',' + (ub + 4) + ' ' + r(t - s - 3) + ',' + (ub + cv - 4) + ' ' + r(t) + ',' + (ub + cv) + ' L' + r(t) + ',' + r(h) + goot(t, h);
    },
    // Monumenten: forse kraal, lang hol, twee sierlijnen op het zichtvlak.
    monumenten: function (t, h) {
      var rb = Math.min(7, t * 0.45), cv = 18, d = Math.min(5, t * 0.35), g = Math.round(h * 0.38);
      return start(t, h) + ' L' + r(t - 1 - rb) + ',0 A' + r(rb) + ' ' + r(rb) + ' 0 0 1 ' + r(t - 1) + ',' + r(rb) + ' L' + r(t - 1) + ',' + r(rb + 1) +
        ' C' + r(t - 1 - 2 * d) + ',' + r(rb + 5) + ' ' + r(t - 1 - 2 * d) + ',' + r(rb + cv - 3) + ' ' + r(t) + ',' + r(rb + 1 + cv) +
        ' L' + r(t) + ',' + r(g - 1.5) + ' L' + r(t - 1.5) + ',' + g + ' L' + r(t) + ',' + r(g + 1.5) +
        ' L' + r(t) + ',' + r(g + 3.5) + ' L' + r(t - 1.5) + ',' + (g + 5) + ' L' + r(t) + ',' + r(g + 6.5) + ' L' + r(t) + ',' + r(h) + goot(t, h);
    },
    // Sierplint: ronde kop op het zichtvlak, kort hol, één sierlijn.
    sier: function (t, h) {
      var rb = Math.min(6, t * 0.5), cv = 12, d = Math.min(4, t * 0.3), g = Math.round(h * 0.4);
      return start(t, h) + ' L' + r(t - rb) + ',0 A' + r(rb) + ' ' + r(rb) + ' 0 0 1 ' + r(t) + ',' + r(rb) + ' L' + r(t) + ',' + r(rb + 1) +
        ' C' + r(t - 2 * d) + ',' + r(rb + 4) + ' ' + r(t - 2 * d) + ',' + r(rb + cv - 2) + ' ' + r(t) + ',' + r(rb + 1 + cv) +
        ' L' + r(t) + ',' + r(g - 1.5) + ' L' + r(t - 1.5) + ',' + g + ' L' + r(t) + ',' + r(g + 1.5) + ' L' + r(t) + ',' + r(h) + goot(t, h);
    }
  };

  // Uitvoering (metaveld custom.uitvoering) of producttitel -> profielnaam.
  function profielVan(uitvoering, titel) {
    var s = ((uitvoering || '') + ' ' + (titel || '')).toLowerCase();
    if (/overzet|renovatie/.test(s)) return 'overzet';
    if (/geluid/.test(s)) return 'geluid';
    if (/kraal/.test(s)) return 'kraal';
    if (/koloni/.test(s)) return 'koloniaal';
    if (/romance/.test(s)) return 'romance';
    if (/monument|renaissance/.test(s)) return 'monumenten';
    if (/sierplint|barok/.test(s)) return 'sier';
    if (/tijdloos|luxe/.test(s)) return 'tijdloos';
    if (/folie|recht/.test(s)) return 'recht';
    return 'modern';
  }

  // RAL-naam -> echte kleur (null als de naam onbekend is). Een opgegeven opts.kleur gaat altijd voor.
  function kleurVan(naam) {
    var m = /\b(9010|9016|9001|9005|7016)\b/.exec(naam || '');
    if (m) return RAL[m[1]];
    if (/grond/i.test(naam || '')) return RAL.grond;
    return null;
  }

  function teken(svg, o) {
    var t = parseFloat(o.dikte), h = parseFloat(o.hoogte);
    if (!svg || !(t > 0) || !(h > 0) || t >= h) return false;
    var naam = o.profiel && PROFIELEN[o.profiel] ? o.profiel : profielVan(o.uitvoering, o.titel);
    var vul = o.kleur || kleurVan(o.kleurNaam) || '#e8e6e1';
    var lijn = o.lijnKleur || '#374151', maat = o.maatKleur || '#324696', grijs = '#9ca3af';
    var extra = EXTRA_MATEN[naam] ? EXTRA_MATEN[naam](t, h, o) : [];

    var s = 180 / Math.max(h, 110);          // px per mm; lage plinten worden niet opgeblazen
    var W = t * s, H = h * s;
    var vlakken = EXTRA_VLAKKEN[naam] ? EXTRA_VLAKKEN[naam](t, h, o) : [];
    var ML = extra.length ? 92 : 42, MT = 48, MR = 86, MB = extra.length ? 56 : 30;
    var vw = ML + W + MR, vh = MT + H + MB;
    var x0 = ML, x1 = ML + W, y0 = MT, y1 = MT + H;

    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute('viewBox', '0 0 ' + r(vw) + ' ' + r(vh));
    svg.setAttribute('role', 'img');
    svg.setAttribute('aria-label', 'Dwarsdoorsnede van de plint, ' + t + ' bij ' + h + ' millimeter');

    var font = 'font-family:Poppins,system-ui,sans-serif;';
    var dimStijl = font + 'font-size:11px;font-weight:600;fill:' + maat + ';paint-order:stroke;stroke:#fff;stroke-width:3px;stroke-linejoin:round;font-variant-numeric:tabular-nums';
    var labStijl = font + 'font-size:9px;fill:' + grijs + ';letter-spacing:.04em;text-transform:uppercase';
    var cmStijl = font + 'font-size:9.5px;font-weight:400;fill:#6b7280;paint-order:stroke;stroke:#fff;stroke-width:3px;stroke-linejoin:round';
    // maatlabel in twee regels: mm (blauw) en daaronder cm (grijs)
    function maatLabel(x, y, mm, anchor) {
      var t = el('text', { x: r(x), y: r(y), style: dimStijl, 'text-anchor': anchor || 'start' });
      var a = el('tspan', { x: r(x), dy: 0 }); a.textContent = mm + ' mm';
      var b = el('tspan', { x: r(x), dy: 11, style: cmStijl }); b.textContent = String(Math.round(mm) / 10).replace('.', ',') + ' cm';
      t.appendChild(a); t.appendChild(b); svg.appendChild(t);
    }

    // wand en vloer. De wand begint op de bovenkant van de plint en niet aan de bovenrand
    // van de tekening, anders loopt hij dwars door de maatlijn en de labels van de dikte.
    svg.appendChild(el('line', { x1: x0, y1: r(y0), x2: x0, y2: r(y1 + 3), stroke: grijs, 'stroke-width': 3 }));
    svg.appendChild(el('line', { x1: r(x0 - 1.5), y1: r(y1), x2: r(vw - 8), y2: r(y1), stroke: grijs, 'stroke-width': 3 }));
    var wand = el('text', { x: r(x0 - 8), y: r(y0 + H / 2), style: labStijl, 'text-anchor': 'middle', transform: 'rotate(-90 ' + r(x0 - 8) + ' ' + r(y0 + H / 2) + ')' });
    wand.textContent = 'wand'; svg.appendChild(wand);
    var vloer = el('text', { x: r((x1 + vw - 8) / 2), y: r(y1 + 14), style: labStijl, 'text-anchor': 'middle' });
    vloer.textContent = 'vloer'; svg.appendChild(vloer);

    // uitsparing(en): gearceerd vlak (schuine strepen) met stippellijn, over de wandlijn heen
    if (vlakken.length) {
      var pid = 'vm-arcering-' + Math.random().toString(36).slice(2, 8);
      var defs = el('defs', {});
      var pat = el('pattern', { id: pid, patternUnits: 'userSpaceOnUse', width: 6, height: 6, patternTransform: 'rotate(45)' });
      pat.appendChild(el('rect', { x: 0, y: 0, width: 6, height: 6, fill: '#eef1f6' }));
      pat.appendChild(el('line', { x1: 0, y1: 0, x2: 0, y2: 6, stroke: '#7c8596', 'stroke-width': 1.4 }));
      defs.appendChild(pat); svg.appendChild(defs);
      vlakken.forEach(function (v) {
        svg.appendChild(el('rect', { x: r(x0 + v.x * s), y: r(y0 + v.y * s), width: r(v.b * s), height: r(v.hg * s), fill: 'url(#' + pid + ')', stroke: '#6b7280', 'stroke-width': 1, 'stroke-dasharray': '3 2' }));
      });
    }

    // profiel, in mm getekend en op schaal gezet
    var g = el('g', { transform: 'translate(' + ML + ',' + MT + ') scale(' + r(s) + ')' });
    g.appendChild(el('path', { d: PROFIELEN[naam](t, h, o), fill: vul, stroke: lijn, 'stroke-width': 1.5, 'stroke-linejoin': 'round', 'vector-effect': 'non-scaling-stroke' }));
    svg.appendChild(g);

    // extra maatlijnen (bv. uitsparing van een overzetplint)
    extra.forEach(function (d) {
      if (d.richting === 'v') {
        var xv = x0 - 32, ya = y0 + d.y1 * s, yb = y0 + d.y2 * s;
        svg.appendChild(el('line', { x1: r(x0 - 2), y1: r(ya), x2: r(xv - 6), y2: r(ya), stroke: maat, 'stroke-width': 1 }));
        svg.appendChild(el('line', { x1: r(x0 - 2), y1: r(yb), x2: r(xv - 6), y2: r(yb), stroke: maat, 'stroke-width': 1 }));
        svg.appendChild(el('line', { x1: r(xv), y1: r(ya), x2: r(xv), y2: r(yb), stroke: maat, 'stroke-width': 1 }));
        svg.appendChild(el('path', { d: 'M' + r(xv) + ' ' + r(ya) + ' l-3 6 h6 z', fill: maat }));
        svg.appendChild(el('path', { d: 'M' + r(xv) + ' ' + r(yb) + ' l-3 -6 h6 z', fill: maat }));
        maatLabel(xv - 8, (ya + yb) / 2 - 2, d.mm, 'end');
      } else {
        var yh = y1 + 14, xa = x0 + d.x1 * s, xb = x0 + d.x2 * s;
        svg.appendChild(el('line', { x1: r(xa), y1: r(y1 + 4), x2: r(xa), y2: r(yh + 6), stroke: maat, 'stroke-width': 1 }));
        svg.appendChild(el('line', { x1: r(xb), y1: r(y1 + 4), x2: r(xb), y2: r(yh + 6), stroke: maat, 'stroke-width': 1 }));
        svg.appendChild(el('line', { x1: r(xa - 16), y1: r(yh), x2: r(xb + 16), y2: r(yh), stroke: maat, 'stroke-width': 1 }));
        svg.appendChild(el('path', { d: 'M' + r(xa) + ' ' + r(yh) + ' l-6 -3 v6 z', fill: maat }));
        svg.appendChild(el('path', { d: 'M' + r(xb) + ' ' + r(yh) + ' l6 -3 v6 z', fill: maat }));
        maatLabel((xa + xb) / 2, yh + 15, d.mm, 'middle');
      }
    });

    // maatlijn dikte (boven, pijlen van buiten naar binnen)
    var yd = MT - 16;
    svg.appendChild(el('line', { x1: x0, y1: r(y0 - 4), x2: x0, y2: r(yd - 6), stroke: maat, 'stroke-width': 1 }));
    svg.appendChild(el('line', { x1: r(x1), y1: r(y0 - 4), x2: r(x1), y2: r(yd - 6), stroke: maat, 'stroke-width': 1 }));
    svg.appendChild(el('line', { x1: r(x0 - 16), y1: yd, x2: r(x1 + 16), y2: yd, stroke: maat, 'stroke-width': 1 }));
    svg.appendChild(el('path', { d: 'M' + x0 + ' ' + yd + ' l-6 -3 v6 z', fill: maat }));
    svg.appendChild(el('path', { d: 'M' + r(x1) + ' ' + yd + ' l6 -3 v6 z', fill: maat }));
    maatLabel((x0 + x1) / 2, yd - 18, t, 'middle');

    // maatlijn hoogte (rechts, pijlen binnen)
    var xh = x1 + 22;
    svg.appendChild(el('line', { x1: r(x1 + 4), y1: y0, x2: r(xh + 6), y2: y0, stroke: maat, 'stroke-width': 1 }));
    svg.appendChild(el('line', { x1: r(x1 + 4), y1: r(y1), x2: r(xh + 6), y2: r(y1), stroke: maat, 'stroke-width': 1 }));
    svg.appendChild(el('line', { x1: r(xh), y1: y0, x2: r(xh), y2: r(y1), stroke: maat, 'stroke-width': 1 }));
    svg.appendChild(el('path', { d: 'M' + r(xh) + ' ' + y0 + ' l-3 6 h6 z', fill: maat }));
    svg.appendChild(el('path', { d: 'M' + r(xh) + ' ' + r(y1) + ' l-3 -6 h6 z', fill: maat }));
    maatLabel(xh + 10, y0 + H / 2 - 2, h, 'start');

    return { profiel: naam };
  }

  teken.profielVan = profielVan;
  teken.kleurVan = kleurVan;
  teken.profielen = Object.keys(PROFIELEN);
  w.vmPlintDoorsnede = teken;
})(window);
